import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { unsubscribe } from "../../services/AdminServices";

const Unsubscribe = () => {
  const { email } = useParams(); // Get the email from the URL
  const [status, setStatus] = useState("");

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        const response = await unsubscribe(encodeURIComponent(email));
        //const response = await fetch(`/api/unsubscribe?email=${encodeURIComponent(email)}`);
        const data = await response.json();
        console.log("Unsubscribe response data:", data);
        if (response.ok) {
          setStatus("success");
        } else {
          setStatus("error");
        }
      } catch (err) {
        console.error(err);
        setStatus("error");
      }
    };

    unsubscribe();
  }, [email]);

  return (
    <div>
      <h1>Unsubscribe</h1>
      {status === "success" && <p>You have been successfully unsubscribed.</p>}
      {status === "error" && (
        <p>
          There was an error processing your request. Please try again later.
        </p>
      )}
    </div>
  );
};

export default Unsubscribe;
